import { render, staticRenderFns } from "./AdminServerTmPage.vue?vue&type=template&id=e05a80c8&"
import script from "./AdminServerTmPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminServerTmPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports